

    <input class="userInput" [disabled]="isInputDisabled" [value]="currentVal"  [(ngModel)]="currentVal"
    type="number" pattern="[0-9]*" placeholder="Enter value" min="0" max="100" text-right style="margin-right:-0.5%;"/>
    <ion-icon (click)="editInput('done')"  class="end-arrow"
        name="md-checkmark" style="color:#c8c7cc;" slot="end" ></ion-icon>
    <ion-icon (click)="editInput('cancel')"  class="end-arrow"
        name="md-close" style="color:#c8c7cc;" slot="end" ></ion-icon>
